import React from 'react';
import PropTypes from 'prop-types';


// import styled
import {
    StyledContainer,
    Sidebar,
    NavList,
    NavLinks,
    NavLink,
    NavListItem,
    ResumeLink
} from './Menu_styled';

import cv from '../../assets/cv_tiavina.pdf';

export const Menu = ({ menuOpen, toggleMenu }) => {
    const handleMenuClick = e => {
        const target = e.target;
        const isLink = target.hasAttribute('href');
        const isNotMenu = target.classList && target.classList[0].includes('StyledContainer');

        if (isLink || isNotMenu) {
            toggleMenu();
        }
    };

    return (
        <StyledContainer
            menuOpen={menuOpen}
            onClick={handleMenuClick}
            aria-hidden={!menuOpen}
            tabIndex={menuOpen ? 1 : -1}>
            <Sidebar>
                <NavLinks>
                    <NavList>
                        <NavListItem>
                            <NavLink to="/home"> Accueil</NavLink>
                            <NavLink to="/skills"> Competences</NavLink>
                            <NavLink to="/projects"> Mes projets</NavLink>
                            <NavLink to="/about"> A propos </NavLink>
                        </NavListItem>
                    </NavList>
                    <ResumeLink 
                        href={cv} 
                        target="_blank" 
                        rel="nofollow noopener noreferrer"
                        download>
                        Télécharger CV
                    </ResumeLink>
                </NavLinks>
            </Sidebar>
        </StyledContainer>

    );
};
Menu.propTypes = {
    menuOpen: PropTypes.bool.isRequired,
    toggleMenu: PropTypes.func.isRequired,
};

